// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-394736be]{list-style:none}ul li[data-v-394736be]:before{content:\"\\2022\";color:red;font-weight:700;display:inline-block;width:1em;margin-right:-1em}", ""]);
// Exports
module.exports = exports;
